import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { msalLoginRequest } from '../../authConfig';
var RequireAuth = function RequireAuth() {
    var _useMsal = useMsal(), instance = _useMsal.instance, inProgress = _useMsal.inProgress, accounts = _useMsal.accounts;
    var hasInitiatedLoginRedirect = useRef(false);
    useEffect(function() {
        if (inProgress === InteractionStatus.None && accounts.length === 0 && !hasInitiatedLoginRedirect.current) {
            hasInitiatedLoginRedirect.current = true;
            instance.loginRedirect(msalLoginRequest).catch(function() {
                hasInitiatedLoginRedirect.current = false;
            });
        }
    }, [
        instance,
        inProgress,
        accounts
    ]);
    return /*#__PURE__*/ _jsx(AuthenticatedTemplate, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
};
export default RequireAuth;
